// @ts-nocheck

import React from 'react';
import styled, { css } from 'styled-components';

import { Target } from '../../../../client';
import GridsSystemGridContainer from '../../containers/grid/GridsSystemGridContainer';
import GridsResetSelectionContainer from '../../containers/GridsResetSelectionContainer';
import GridsSystemActionsContainer from '../../containers/GridsSystemActionsContainer';
import GridsFlashButtonContainer from '../../containers/pool/GridsFlashButtonContainer';

import SystemGridAmount from './SystemGridAmount';

const Wrap = styled.div``;

const WrapButtons = styled(Wrap)`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1em 0;
  padding: 1em;
`;

const Line = styled.div`
  width: 100%;
  height: 1px;
  background-color: ${({ theme }) => theme.grids.colors.darkgrey3};
  margin: 2em 0;
`;

const StyledGridsSystemActionsContainer = styled(GridsSystemActionsContainer)`
  ${({ theme }) =>
    !Target.__MOBILE__
      ? css`
          padding: 1em 0;
          margin: 1em 0;
          ${theme.grids.desktopBloc}
        `
      : undefined}
`;

const StyledGridsSystemGridContainer = styled(GridsSystemGridContainer)``;

const StyledGridsResetSelectionContainer = styled(GridsResetSelectionContainer)``;

const GridBloc = styled.div`
  ${({ theme }) =>
    !Target.__MOBILE__
      ? css`
          padding: 2em 0;
          margin: 0 0 1em 0;
          ${theme.grids.desktopBloc}
        `
      : undefined}
`;

type GridsSystemListProps = {
  className?: string;
  grids: Array<{
    selectionIndex: number;
    amount: string;
    selection: string;
  }>;
  poolId: number;
  isReadOnly: boolean;
};

const GridsSystemList = ({ className, grids, poolId, isReadOnly = false }: GridsSystemListProps) => {
  return (
    <Wrap className={className}>
      {grids?.map(({ selection, selectionIndex, amount }, index) => (
        <div key={`${grids.length}${index}`}>
          {isReadOnly && Target.__MOBILE__ && <Line />}
          <GridBloc>
            <SystemGridAmount amount={amount} />
            <StyledGridsSystemGridContainer
              poolId={poolId}
              selection={selection}
              selectionIndex={selectionIndex}
              isReadOnly={isReadOnly}
            />
            {!isReadOnly && (
              <>
                <WrapButtons>
                  <StyledGridsResetSelectionContainer selectionIndex={selectionIndex} />
                  <GridsFlashButtonContainer selectionIndex={selectionIndex} />
                </WrapButtons>
              </>
            )}
          </GridBloc>
          {!isReadOnly && <StyledGridsSystemActionsContainer selectionIndex={selectionIndex} />}
        </div>
      ))}
    </Wrap>
  );
};

export default GridsSystemList;
